// Kenny's pace zones from a current mile time (seconds), via percent-of-mile-pace
// (research-corroborated): easy +3:00, tempo +1:00, interval +0:12, reps -0:15 per mile.

function fmt(sec) {
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

function zone(paceSec) {
  const mph = 3600 / paceSec; // sec/hr ÷ sec/mi = mi/hr
  return { paceSec, pace: fmt(paceSec), mph: Math.round(mph * 10) / 10 };
}

export function paceZones(mileSec) {
  return {
    easy: zone(mileSec + 180),
    tempo: zone(mileSec + 60),
    interval: zone(mileSec + 12),
    reps: zone(mileSec - 15),
    mile: zone(mileSec),
  };
}
